import React, { useEffect, useState } from "react";
import Header from "../master/SideBar.jsx";
import Nav from "../master/NavBar.jsx";
import { SweetAlertShow, LoadingDiv } from "../master/Master.jsx";
import Master from "./Master.jsx";
import usePrivateLink from "../config/usePrivateLink.js";
import { courseList } from "../../api/Courses.js";
import { batchList } from "../../api/Batch.js";
import Pagination from "../components/Pagination.jsx";
import { printImg } from "../master/Print.jsx";
import { formatToDate } from "../master/FormatToDateTime.jsx";
import { studentRegPending, studentRegPendingV4 } from "../../api/FeesDeposite.js";
import { Link } from "react-router-dom";

export default function StudentDueRegistration() {
    const hasAccess = usePrivateLink();
    const [filters, setFilters] = useState({
        search: "",
        month: "",
        course_id: "",
        batch_id: "",
        session_id: "", page: 1,
    });
    const [error, setError] = useState("");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [sessions, setSessions] = useState([]);
    const [batches, setBatches] = useState([]);
    const [courses, setCourses] = useState([]);


    const handleFunction = () => {
        getBatchList({
            setLoading,
            filters,
            setData,
        });
    };

    useEffect(() => {
        handleFunction();
    }, [filters]);


    const getBatchList = async () => {
        try {
            setLoading(true);

            const params = new URLSearchParams();

            if (filters.course_id) {
                params.append("course_id", filters.course_id);
            }

            if (filters.session_id) {
                params.append("session_id", filters.session_id);
            }

            const response = await batchList(params.toString());


            if (response.data.status) {
                setBatches(response?.data?.data || []);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ??
                error?.message
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getBatchList();
    }, [filters.course_id, filters.session_id]);


    const courseFetch = async () => {
        try {
            setLoading(true);

            const response = await courseList();

            if (response.data.status) {
                setCourses(response?.data?.data || []);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ??
                error?.message
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        courseFetch();
    }, []);

    useEffect(() => {
        const parseSessions = JSON.parse(
            localStorage.getItem("sessions") ?? "[]"
        );

        setSessions(parseSessions);
    }, []);

    useEffect(() => {
        const activeSession = sessions?.find(
            (s) => Number(s.status) === 1
        )?.id;

        setFilters((prev) => {
            if (prev.session_id || !activeSession) return prev;

            return {
                ...prev,
                session_id: activeSession,
            };
        });
    }, [sessions]);



    const getStudents = async () => {
        try {
            setLoading(true);

            const query = new URLSearchParams(
                Object.fromEntries(
                    Object.entries(filters).filter(
                        ([_, value]) =>
                            value !== "" &&
                            value !== null &&
                            value !== undefined
                    )
                )
            ).toString();

            console.log(query);

            const response = await studentRegPendingV4(query);

            if (response?.data?.status) {
                setData(response?.data?.data);
                setError("");
            } else {
                setData({});
                setError(response?.data?.message);
            }
        } catch (error) {
            setData({});

            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ??
                error?.message
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            getStudents();
        }, 500);

        return () => clearTimeout(timer);
    }, [filters]);


    return (
        <>
            {loading && <LoadingDiv />}
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="content-wrapper">
                            <div className="container-fluid flex-grow-1 container-p-y">
                                <div className="row">
                                    <Master />
                                    <div className="col-md-12 right-pane">

                                        <div className="card p-3 mb-3 shadow-sm border-0">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div
                                                        style={{
                                                            width: 45,
                                                            height: 45,
                                                            borderRadius: "12px",
                                                            background:
                                                                "linear-gradient(45deg,#185fa5,#4f8cff)",
                                                            color: "#fff",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        <i className="ri-money-rupee-circle-line fs-3"></i>
                                                    </div>

                                                    <div>
                                                        <h5 className="m-0 fw-bold">Registration Fee Pending Report</h5>
                                                        <small>
                                                            Students with Incomplete Registration Fee Payment
                                                        </small>
                                                    </div>
                                                </div>

                                                <div className="d-flex align-items-center gap-2">



                                                    <div className="d-flex flex-wrap gap-2 mb-3">
                                                        {/* SESSION */}
                                                        {filters.session_id && (
                                                            <span className="badge bg-primary-subtle text-primary px-3 py-2">
                                                                Session:{" "}
                                                                {
                                                                    sessions.find(
                                                                        (s) => s.id == filters.session_id,
                                                                    )?.session
                                                                }
                                                                <i
                                                                    className="ri-close-line ms-2 cursor-pointer"
                                                                    onClick={() =>
                                                                        setFilters({ ...filters, session_id: "" })
                                                                    }
                                                                ></i>
                                                            </span>
                                                        )}

                                                        {/* SEARCH */}
                                                        {filters.search && (
                                                            <span className="badge bg-dark-subtle text-dark px-3 py-2">
                                                                Search: {filters.search}
                                                                <i
                                                                    className="ri-close-line ms-2 cursor-pointer"
                                                                    onClick={() =>
                                                                        setFilters({ ...filters, search: "" })
                                                                    }
                                                                ></i>
                                                            </span>
                                                        )}



                                                        {/* BATCH */}
                                                        {filters.batch_id && (
                                                            <span className="badge bg-warning-subtle text-dark px-3 py-2">
                                                                Batch:{" "}
                                                                {
                                                                    batches.find((b) => b.id == filters.batch_id)
                                                                        ?.title
                                                                }
                                                                <i
                                                                    className="ri-close-line ms-2 cursor-pointer"
                                                                    onClick={() =>
                                                                        setFilters({ ...filters, batch_id: "" })
                                                                    }
                                                                ></i>
                                                            </span>
                                                        )}




                                                    </div>

                                                    <button
                                                        title="Open Filters"
                                                        className="btn btn-light border rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                                        data-bs-toggle="offcanvas"
                                                        data-bs-target="#filterCanvas"
                                                        style={{ width: 40, height: 40 }}
                                                    >
                                                        <i className="ri-filter-3-line text-primary"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>




                                        <div className="card border-0 shadow-sm p-2 " id="print">
                                            <div className="card-body p-0">

                                                <div className="d-flex justify-content-end align-items-center mb-3">
                                                    <div style={{ width: "300px" }}>
                                                        <div className="form-floating form-floating-outline">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Student Name/Mobile/Registration"
                                                                value={filters?.search}
                                                                onChange={(e) =>
                                                                    setFilters({
                                                                        ...filters,
                                                                        search: e.target.value.toUpperCase(),
                                                                        page: 1,
                                                                    })
                                                                }
                                                            />
                                                            <label>Name/Mobile/Reg. No</label>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="table-responsive">

                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>Sr.No</th>
                                                                <th>Name / Reg. No</th>
                                                                <th>Course</th>
                                                                <th>Batch</th>
                                                                <th>Mobile No</th>
                                                                <th>DOJ</th>
                                                                <th>Reg Fees</th>
                                                                <th>Action</th>



                                                            </tr>
                                                        </thead>

                                                        <tbody >
                                                            {data?.data?.length > 0 ? (
                                                                data.data.map((student, index) => {
                                                                    const course_and_fees = student?.latest_course_and_fee;
                                                                    const fees = student?.course_and_fees;
                                                                    const totalPendingRegFee =
                                                                        fees?.reduce((total, item) => {
                                                                            return (
                                                                                total +
                                                                                (Number(item.reg_fee || 0) -
                                                                                    Number(item.paid_reg_fee || 0))
                                                                            );
                                                                        }, 0) || 0;


                                                                    return (
                                                                        <tr key={student.id}>
                                                                            <td className="fw-bold ">
                                                                                {student?.rn ?? index + 1}
                                                                            </td>
                                                                            <td className="fw-bold text-primary">
                                                                                <Link
                                                                                    to={`/student/details?id=${student.id}`}
                                                                                    className="text-decoration-none"
                                                                                >
                                                                                    <div>
                                                                                        <div className="fw-bold">{student.name}</div>
                                                                                        <small className="text-muted">
                                                                                            {student.registration_no}
                                                                                        </small>
                                                                                    </div>
                                                                                </Link>
                                                                            </td>

                                                                            <td className="fw-bold ">{course_and_fees?.course?.title ?? "-"}</td>

                                                                            <td className="fw-bold text-success ">{course_and_fees?.batch?.title ?? "-"}</td>


                                                                            <td className="fw-bold ">{student.phone}</td>

                                                                            <td className="fw-bold">
                                                                                {course_and_fees?.admission_date
                                                                                    ? formatToDate(course_and_fees?.admission_date)
                                                                                    : "-"}
                                                                            </td>




                                                                            <td className="text-end text-danger">
                                                                                <div className="fw-bold">
                                                                                    ₹ {totalPendingRegFee.toLocaleString()}
                                                                                </div>
                                                                            </td>


                                                                            <td className="text-end">
                                                                                <a
                                                                                    href={`/student/fees/deposit?id=${student.id}`}
                                                                                    className="btn btn-sm btn-warning"
                                                                                >
                                                                                    <i className="ri-money-rupee-circle-line"></i>

                                                                                </a>
                                                                            </td>



                                                                        </tr>
                                                                    );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="8" className="text-center py-4">
                                                                        No Due Fees Found
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>

                                                    <Pagination data={data} setFilters={setFilters} filters={filters} />
                                                </div>
                                            </div>
                                        </div>






                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <div className="offcanvas offcanvas-end" tabIndex="-1" id="filterCanvas">
                {/* HEADER */}
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title"> Filters</h5>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="offcanvas"
                    ></button>
                </div>

                {/* BODY */}
                <div className="offcanvas-body">
                    <div className="row">

                        <div className="col-12 mb-3">
                            <div className="form-floating form-floating-outline ">
                                <select
                                    className="form-select"
                                    value={filters?.session_id}
                                    onChange={(e) => {
                                        setFilters({
                                            ...filters,
                                            session_id: e.target.value,
                                        });
                                    }}
                                >
                                    <option value="all">All</option>
                                    {sessions.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.session}:
                                            {Number(item.status) === 1 ? "Active" : "Inactive"}
                                        </option>
                                    ))}
                                </select>
                                <label>Filter Session</label>
                            </div>
                        </div>


                        <div className="col-12 mb-3">
                            <div className="form-floating form-floating-outline">
                                <select
                                    className="form-select"
                                    value={filters?.course_id}
                                    onChange={(e) =>
                                        setFilters({
                                            ...filters,
                                            course_id: e.target.value,
                                            batch_id: "",
                                            page: 1,
                                        })
                                    }
                                >
                                    <option value="">All Courses</option>

                                    {courses?.map((course) => (
                                        <option key={course.id} value={course.id}>
                                            {course.title}
                                        </option>
                                    ))}
                                </select>

                                <label>Course</label>
                            </div>
                        </div>

                        <div className="col-12 mb-3">
                            <div className="form-floating form-floating-outline">
                                <select
                                    className="form-select"
                                    value={filters?.batch_id}
                                    onChange={(e) =>
                                        setFilters({
                                            ...filters,
                                            batch_id: e.target.value,
                                            page: 1,
                                        })
                                    }
                                >
                                    <option value="">All Batches</option>

                                    {batches?.map((batch) => (
                                        <option key={batch.id} value={batch.id}>
                                            {batch.title}
                                        </option>
                                    ))}
                                </select>

                                <label>Batch</label>
                            </div>
                        </div>






                    </div>

                    <div className="row g-2 mt-3">
                        <div className="col-6">
                            <button
                                className="btn btn-primary w-100"
                                data-bs-dismiss="offcanvas"
                            >
                                Apply
                            </button>
                        </div>

                        <div className="col-6">
                            <button
                                className="btn btn-outline-danger w-100"
                                onClick={() =>
                                    setFilters({
                                        search: "",
                                        course_id: "",
                                        batch_id: "",
                                        session_id: sessions?.find(
                                            (s) => Number(s.status) === 1
                                        )?.id,

                                        page: 1,
                                    })
                                }
                            >
                                Reset
                            </button>
                        </div>


                        <button
                            className="btn btn-outline-danger"
                            onClick={() =>
                                printImg("print", setLoading, filters)
                            }
                        >
                            <i className="ri-printer-line me-1"></i>
                            Print
                        </button>
                    </div>
                </div>
            </div>

        </>
    );
}
